var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
/**
 * Represents the [KendoReact NotificationGroup component]({% slug api_notification_notificationgroup %}).
 */

var NotificationGroup = function (_super) {
  __extends(NotificationGroup, _super);

  function NotificationGroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @hidden
   */


  NotificationGroup.prototype.render = function () {
    var _a = this.props,
        _b = _a.style,
        style = _b === void 0 ? {} : _b,
        className = _a.className;
    return React.createElement("div", {
      className: 'k-notification-group' + (className ? " " + className : ''),
      style: __assign({
        alignItems: 'center',
        flexWrap: 'wrap'
      }, style)
    }, this.props.children);
  };
  /**
   * @hidden
   */


  NotificationGroup.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object
  };
  return NotificationGroup;
}(React.Component);

export default NotificationGroup;